"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleApplyKeyPreferences = exports.handleSetKeyPreferences = exports.changeSpectrumVerticalAlignment = void 0;
const GroupByInfoKey_1 = __importDefault(require("../../utility/GroupByInfoKey"));
const nucleusToString_1 = __importDefault(require("../../utility/nucleusToString"));
const getActiveSpectrum_1 = require("../helper/getActiveSpectrum");
const DomainActions_1 = require("./DomainActions");
function changeSpectrumVerticalAlignment(draft, options) {
    const { verticalAlign = 'bottom', activeTab } = options;
    const nucleus = activeTab || draft.view.spectra.activeTab;
    if (draft.data && draft.data.length > 0) {
        let dataPerNucleus = [];
        if (['auto-check', 'stack'].includes(options.verticalAlign || '')) {
            dataPerNucleus = draft.data.filter((datum) => datum.info.nucleus === nucleus && datum.info.dimension === 1);
        }
        if (nucleus) {
            if (verticalAlign === 'auto-check') {
                const isFid = dataPerNucleus[0]?.info.isFid &&
                    !dataPerNucleus.some((d) => !d.info.isFid);
                if (isFid) {
                    draft.view.verticalAlign[nucleus] = 'center';
                }
                else {
                    let hasMoreThanOnFt = false;
                    let count = 1;
                    for (const spectrum of dataPerNucleus) {
                        if (count > 1) {
                            hasMoreThanOnFt = true;
                            break;
                        }
                        if (spectrum.info.isFt) {
                            count++;
                        }
                    }
                    if (hasMoreThanOnFt) {
                        draft.view.verticalAlign[nucleus] = 'stack';
                    }
                    else {
                        draft.view.verticalAlign[nucleus] = 'bottom';
                    }
                }
            }
            else {
                draft.view.verticalAlign[nucleus] = verticalAlign;
            }
        }
    }
}
exports.changeSpectrumVerticalAlignment = changeSpectrumVerticalAlignment;
function handleSetKeyPreferences(draft, action) {
    const { keyCode } = action.payload;
    const { data, zoom, xDomain, xDomains, yDomain, yDomains, originDomain, margin, displayerMode, view, keysPreferences, } = draft;
    const { spectra: { activeTab }, } = view;
    const activeSpectrum = (0, getActiveSpectrum_1.getActiveSpectrum)(draft);
    if (activeTab) {
        const groupByNucleus = (0, GroupByInfoKey_1.default)('nucleus');
        const spectrumsGroupsList = groupByNucleus(data);
        const spectra = spectrumsGroupsList[activeTab];
        keysPreferences[keyCode] = {
            activeSpectrum,
            displayerMode,
            view,
            zoom,
            xDomain,
            xDomains,
            yDomain,
            yDomains,
            originDomain,
            margin,
            data: spectra,
        };
    }
}
exports.handleSetKeyPreferences = handleSetKeyPreferences;
function setSpectraDisplayPreferences(draft, preferences) {
    for (const [index, datum] of draft.data.entries()) {
        if ((0, nucleusToString_1.default)(datum.info.nucleus) === preferences.activeTab) {
            draft.data[index].display = {
                ...datum.display,
                ...preferences.data[datum.id].display,
            };
        }
    }
}
function handleApplyKeyPreferences(draft, action) {
    const { keyCode } = action.payload;
    const preferences = draft.keysPreferences[keyCode];
    if (preferences) {
        setSpectraDisplayPreferences(draft, preferences);
        draft.view = preferences.view;
        draft.displayerMode = preferences.displayerMode;
        draft.margin = preferences.margin;
        (0, DomainActions_1.setDomain)(draft);
        draft.xDomain = preferences.xDomain;
        draft.xDomains = preferences.xDomains;
        draft.yDomain = preferences.yDomain;
        draft.originDomain = preferences.originDomain;
        draft.yDomains = preferences.yDomains;
        if (draft.displayerMode !== '2D') {
            draft.zoom = preferences.zoom;
        }
    }
}
exports.handleApplyKeyPreferences = handleApplyKeyPreferences;
